import { render, staticRenderFns } from "./RelatorioFormularioRespostaRoute.vue?vue&type=template&id=4ff54499"
import script from "./RelatorioFormularioRespostaRoute.vue?vue&type=script&lang=js"
export * from "./RelatorioFormularioRespostaRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports